import { Routes } from '@angular/router';

import { SERVICE_ANALYTICS } from '../shared/models/list';

import { CoilCalculatorComponent } from './components/coil-calculator.component';

export const routes: Routes = [
	{
		path: '',
		data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.COIL_CALCULATOR },
		children: [
			{
				path: 'coil-calculator',
				component: CoilCalculatorComponent,
				data: { pageName: 'Coil Calculator', service: SERVICE_ANALYTICS.COIL_CALCULATOR }
			}
		]
	}
];
